import JsonView from '@uiw/react-json-view'

import useReactiveSessionStorage from '@web/hooks/useReactiveSessionStorage'
import { IS_DEV } from '@web/libs/constants'

export const PROPS_VIEWER_MODE_KEY = 'PROPS_VIEWER_MODE'

/**
 * TODO: contentEditable를 사용해서 props 편집 모드
 */
export const usePropsViewerMode = ({ props }: { props?: object | undefined }) => {
  const [clickCodeDebugMode] = useReactiveSessionStorage<boolean>(PROPS_VIEWER_MODE_KEY)

  const showable = clickCodeDebugMode && IS_DEV

  return {
    PropsViewer: showable ? <JsonView value={props} displayDataTypes={false} displayObjectSize /> : null,
  }
}
